import { Navigate } from "react-router-dom"
import { isAuthenticated } from "../../services/userService"
import Home from "../../routes/home"

// "/": logged-in users go to their dashboard; everyone else gets the
// sign-up home page (plan B2.5).
export default function RootRedirect() {
    return isAuthenticated() ? <Navigate to="/dashboard" replace /> : <Home />
}
